export default __webpack_public_path__ + "logo-lb-7d612798316ea84d34f5a1419cb150ead09adf3d58b02109b07c81c7d0eb2c34.png";